import { render, staticRenderFns } from "./DsarPerClosure.vue?vue&type=template&id=0b6bfe69&"
import script from "./DsarPerClosure.vue?vue&type=script&lang=js&"
export * from "./DsarPerClosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports